import $ from 'jquery';

export const hideAllMenus = () => {
  $('#editor-menu-default').hide();
  $('#editor-menu-text').hide();
  $('#editor-menu-object').hide();
  $('#editor-menu-images').hide();
  $('#editor-menu-crop').hide();
  $('#editor-menu-svg').hide();
  $('#editor-menu-images-cropping-commands').hide();
  $('[data-feature="magic-frame"]').hide();
};
